export default {
    infoWork: 'ลงเวลาสำเร็จ',
    time: 'เวลา',
    now: 'ขณะนี้เวลา',
    confirm: 'ยืนยัน'
}
